import AuthService from '../services/auth.service';

export const auth = {
    namespaced: true,
    state: { status: { loggedIn: false }, user: null },
    getters: {
        isAuthenticated: (state) => state.status.loggedIn,
        currentUser: (state) => state.user,
        currentUserToken: (state) => state.user?.token || null,
        isTokenValid: (state) => {
            const expire = state.user?.token_expire;
            if (!expire) return false;

            return expire > Date.now();
        },
        userRole: (state) => state.user?.tipoUsuario || null,
        hasRole: (state) => (role) => state.user?.tipoUsuario === role,
    },
    actions: {
        loadStoredUser({ commit }) {
            const user = JSON.parse(localStorage.getItem('user'));
            const token = localStorage.getItem('token');
            const expire = localStorage.getItem('token_expire');

            if (user && token) {
                commit('SET_USER', user);
                commit('SET_TIPO_USUARIO', user.tipoUsuario);
                commit('SET_TOKEN', token);
                commit('SET_TOKEN_EXPIRE', expire);
                commit('SET_LOGGED_IN', true);
            } else {
                commit('SET_LOGGED_IN', false);
            }
        },
        login({ commit }, user) {
            return AuthService.login(user).then(
                response => {
                    commit('loginSuccess', response);
                    return Promise.resolve(response);
                },
                error => {
                    commit('loginFailure');
                    return Promise.reject(error);
                }
            );
        },
        logout({ commit }) {
            AuthService.logout();
            commit('logout');
        },
        register({ commit }, user) {
            return AuthService.register(user).then(
                response => {
                    commit('registerSuccess');
                    return Promise.resolve(response.data);
                },
                error => {
                    commit('registerFailure');
                    return Promise.reject(error);
                }
            );
        },
        recoverPassword({commit}, user) {
            return AuthService.recoverPassowrd(user).then(
                response => {
                    commit('recoverPassowrd');
                    return Promise.resolve(response.data);
                },
                error => {
                    commit('recoverPasswordFailure');
                    return Promise.reject(error);
                }
            );
        },
        reset({commit}, user) {
            return AuthService.reset(user).then(
                response => {
                    commit('resetPassowrd');
                    return Promise.resolve(response.data);
                },
                error => {
                    commit('resetPasswordFailure');
                    return Promise.reject(error);
                }
            );
        }
    },
    mutations: {
        loginSuccess(state, user) {
            state.status.loggedIn = true;
            state.user = user.user;
            state.user.token_expire = new Date(user.token_expire).getTime();

            localStorage.setItem('user', JSON.stringify(user.user));
            localStorage.setItem('token', user.token);
            localStorage.setItem('tipoUsuario', user.tipoUsuario);
            localStorage.setItem('token_expire', user.token_expire);
            localStorage.setItem('expiresAt', user.expiresAt);
        },
        loginFailure(state) {
            state.status.loggedIn = false;
            state.user = null;

            localStorage.removeItem('user');
            localStorage.removeItem('token');
            localStorage.removeItem('tipoUsuario');
            localStorage.removeItem('expiresAt');
            localStorage.removeItem('token_expire');
        },
        logout(state) {
            state.status.loggedIn = false;
            state.user = null;

            localStorage.removeItem('user');
            localStorage.removeItem('token');
            localStorage.removeItem('tipoUsuario');
            localStorage.removeItem('expiresAt');
            localStorage.removeItem('token_expire');
        },
        registerSuccess(state) {
            state.status.loggedIn = false;
        },
        registerFailure(state) {
            state.status.loggedIn = false;
        },
        recoverPasswordFailure(state) {
            state.status.loggedIn = false;
        },
        recoverPassowrd(state) {
            state.status.loggedIn = false;
            state.user = null;
        },
        resetPassowrd(state) {
            state.status.loggedIn = false;
        },
        resetPasswordFailure(state) {
            state.status.loggedIn = false;
        },
        SET_LOGGED_IN(state, value) {
            state.status.loggedIn = value;
        },
        SET_USER(state, user) {
            state.user = user;
        },
        SET_TIPO_USUARIO(state, tipoUsuario) {
            if (!state.user) state.user = {};
            state.user.tipoUsuario = tipoUsuario;
        },
        SET_TOKEN(state, token) {
            if (!state.user) state.user = {};
            state.user.token = token;
        },
        SET_TOKEN_EXPIRE(state, token_expire) {
            if (!state.user) state.user = {};
            state.user.token_expire = new Date(token_expire).getTime();
        }
    }
};